export default "__VITE_ASSET__9a58e6d0__"